<section class="public-page terms-page">
  <div class="public-page-shell public-page-shell--narrow">
    <div class="public-page-panel terms-shell">
      <p class="public-page-meta">{{ 'data_protection.effective_date_label' | translate }}: {{ 'data_protection.effective_date' | translate }}</p>
      <h1 class="public-page-title terms-title">{{ 'data_protection.title' | translate }}</h1>
      <p class="public-page-intro terms-intro">{{ 'data_protection.intro' | translate }}</p>

      <section class="public-page-section terms-section" *ngFor="let sectionId of sectionIds">
        <h2 class="public-page-card-title">{{ ('data_protection.sections.' + sectionId + '.title') | translate }}</h2>
        <p class="public-page-body" *ngFor="let paragraphId of paragraphIds">
          {{ ('data_protection.sections.' + sectionId + '.paragraphs.' + paragraphId) | translate }}
        </p>
      </section>
    </div>
  </div>
</section>
